import styles from './Step.module.scss';

interface Props {
  isActivated: boolean
  onClickStep?: () => void,
  label: string,
  order: number  
}
  // `step ${isActivated ? 'is-active' : ''}`
export const Step = ({ isActivated, onClickStep, label, order  }: Props) => {  
  return (
    <div 
      className={`${styles.step} ${isActivated ? styles.isActive : ''}`}
      onClick={onClickStep}
    >
      <p className={styles.order}>{order}</p>
      <p className={styles.label}>{label}</p>
      <div className={`${styles.tail} ${styles.tailBefore}`}></div>
      <div className={`${styles.tail} ${styles.tailAfter}`}></div>
    </div>
  )
}
